import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  sponsors: [],
  fetchLoading: false,
  singleSponsor: null,
};

const slice = createSlice({
  name: "sponsor",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateSponsorSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.sponsors = state.sponsors.map((sponsor) => {
        if (sponsor.id === action.payload.id) {
          return action.payload;
        }
        return sponsor;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getSponsorSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.sponsors = action.payload;
    },

    getSingleSponsorSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleSponsor = action.payload;
    },

    // GET PRODUCTS
    createSponsorSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.sponsors = [action.payload, ...state.sponsors];
    },

    // DELETE EVENT
    deleteSponsorSuccess(state, action) {
      const sponsorId = action.payload;
      state.sponsors = state.sponsors.filter(
        (sponsor) => sponsor.slug !== sponsorId
      );
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getSponsors({ params }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("partners", {
        params,
      });
      dispatch(slice.actions.getSponsorSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleSponsor({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`partners/${id}`);
      dispatch(slice.actions.getSingleSponsorSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createSponsor({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("partners", data);
      dispatch(slice.actions.createSponsorSuccess(response.data.data));
      enqueueSnackbar("Sponsor is added successfully");
      navigate(-1);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateSponsor({
  id,
  data,
  enqueueSnackbar,
  setOpenEdit,
  navigate,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`partners/${id}`, data);
      dispatch(slice.actions.updateSponsorSuccess(response.data.data));
      enqueueSnackbar("Sponsor is updated successfully");
      navigate && navigate(-1);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteSponsor({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`partners/${id}`);
      dispatch(slice.actions.deleteSponsorSuccess(id));
      enqueueSnackbar("Sponsor is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
